// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Turkey from '../_raw/flag/icon_flag_turkey.png';

export default () => <img src={Turkey} alt="Turkey" />;
